import { createRouter, createWebHistory } from "vue-router";
import silentLogin from "@/components/silent_login/Login.vue";
import notfound from "@/views/NotFound.vue";
import login from "../views/nest_views/login.vue";
import servicerepairhistory from "../views/nest_views/service-repair-history.vue";
import plan from "../views/protection-plan/plan.vue";
import salesHistory from "../views/protection-plan-partner/sales-history.vue";
import commisions from "../views/protection-plan-partner/commisions.vue";
import register from "../views/nest_views/register.vue";
import verification from "../views/nest_views/verification.vue";
import forgetPassword from "../views/nest_views/reset-password.vue"
import search from "../views/globalSearch/search.vue";
import protectionPlans from "../views/protection-plan/index.vue";
import { enableScroll } from "../helpers/scrollHelper";
import affiliates from "../views/protection-plan-partner/affiliates.vue";
import partnerList from "../views/protection-plan-partner/bundle-list.vue";
import partnerCheckout from "../views/protection-plan-partner/partner-checkout/chekout.vue";
import thankyou from "../views/protection-plan-partner/partner-checkout/thankyou.vue";
import productList from "../views/protection-plan-partner/products.vue";
import termsAndConditions from "../views/protection-plan-partner/partner-checkout/terms-and-condtion.vue";
import dashboardHappyHome from "../views/myHappyHome/dashboard.vue";
import passwordReset from "../views/nest_views/password-reset.vue"
import privacyPolicy from "../views/myHappyHome/privacy-policy.vue";
import contractorAgreement from "../views/myHappyHome/contractor-agreement.vue";
import contactus from "../views/contact-us.vue";
import commisionRules from "../views/commissionRule/commission-rule.vue";
import gallery from "../views/galleryView/gallery.vue";
import ssoLogin from "../components/sso/Login.vue";
import networkAffiliate from "../views/protection-plan-partner/network-affiliate/index.vue"


const routes = [
    {
        path: "/",
        name: "login",
        component: login,
        meta: {
            layout: 'auth'
        }
    },
    {
        path: "/login",
        name: "login",
        component: login,
        meta: {
            layout: 'auth'
        }
    },
    {
        path: "/register",
        name: "register",
        component: register,
        meta: {
            layout: 'auth'
        }
    },
    {
        path: "/verification",
        name: "verification",
        component: verification,
        meta: {
            layout: 'auth'
        }
    },
    {
        path: "/password/reset",
        name: "passwordReset",
        component: passwordReset,
        meta: {
            layout: 'auth'
        }
    },
    {
        path: "/forgetPassword",
        name: "forgetPassword",
        component: forgetPassword,
        meta: {
            layout: 'auth'
        }
    },
    {
        path: "/",
        name: "silentLogin",
        component: silentLogin,
        meta: {
            layout: 'auth'
        }
    },
    {
        path: "/not-found",
        name: "NotFound",
        meta: {
            requiresAuth: true, // Add meta field to indicate protected route
            // layout: 'main' 
            layout: 'auth'
        },
        component: notfound,
    },
    {
        path: "/dashboard",
        name: "dashboard",
        component: dashboardHappyHome,
        meta: {
            requiresAuth: true, // Add meta field to indicate protected route
            layout: 'main'
        },
    },
    {
        path: "/service-repair-history",
        name: "service-repair-history",
        component: servicerepairhistory,
        meta: {
            requiresAuth: true, // Add meta field to indicate protected route
            layout: 'main'
        },
    },
    {
        path: "/plans/nrg/:id",
        name: "protections-plans",
        component: protectionPlans,
        meta: {
            requiresAuth: false, // Add meta field to indicate protected route
            layout: 'main'
        },
    },
    {
        path: "/protection-plan/nrg/plan",
        name: "plan",
        component: plan,
        meta: {
            requiresAuth: true, // Add meta field to indicate protected route
            layout: 'main'
        },
    },
    {
        path: "/protection-plan/sales-history",
        name: "salesHistory",
        component: salesHistory,
        meta: {
            requiresAuth: true, // Add meta field to indicate protected route
            layout: 'main'
        },
    },
    {
        path: "/protection-plan/commissions",
        name: "commisions",
        component: commisions,
        meta: {
            requiresAuth: true, // Add meta field to indicate protected route
            layout: 'main'
        },
    },
    {
        path: "/protection-plan/:partnerSlug/products",
        name: "products",
        component: productList,
        meta: {
            requiresAuth: true, // Add meta field to indicate protected route
            layout: 'main'
        },
    },
    {
        path: "/protection-plan/:partnerSlug/:routeSlug",
        name: "partner",
        component: partnerList,
        meta: {
            requiresAuth: true, // Add meta field to indicate protected route
            layout: 'main'
        },
    },
    {
        path: "/global-search",
        name: "globalSearch",
        component: search,
        meta: {
            requiresAuth: true, // Add meta field to indicate protected route
            layout: 'main'
        },
    },
    // ------------------------
    // omega 
    {
        path: "/affiliates",
        name: "affiliates",
        component: affiliates,
        meta: {
            requiresAuth: true, // Add meta field to indicate protected route
            // layout: 'main' 
            layout: 'main'
        },
    },
    // ------------------------
    // partner-checkout 
    {
        path: "/partner/checkout",
        name: "partnerCheckout",
        component: partnerCheckout,
        meta: {
            requiresAuth: true, // Add meta field to indicate protected route
            // layout: 'main' 
            layout: 'main'
        },
    },
    // ------------------------
    // partner-checkout 
    {
        path: "/thankyou",
        name: "thankyou",
        component: thankyou,
        meta: {
            requiresAuth: false, // Add meta field to indicate protected route
            // layout: 'main' 
            layout: 'default'
        },
    },
    // Terms and Conditon
    {
        path: "/terms-and-conditions",
        name: "termsAndConditions",
        component: termsAndConditions,
        meta: {
            requiresAuth: false, // Add meta field to indicate protected route
            // layout: 'main' 
            layout: 'default'
        },
    },
    // ------------------------
    {
        path: "/happyhome/dashboard",
        name: "dashboardHappyHome",
        component: dashboardHappyHome,
        meta: {
            requiresAuth: false, // Add meta field to indicate protected route
            layout: 'main'
            // layout: 'default'
        },
    },
    // ------------------------
    {
        path: "/myhappyhome/privacy-policy",
        name: "privacyPolicy",
        component: privacyPolicy,
        meta: {
            requiresAuth: false, // Add meta field to indicate protected route
            layout: 'default'
            // layout: 'default'
        },
    },
    // ------------------------
    {
        path: "/myhappyhome/contractor-agreement",
        name: "contractorAgreement",
        component: contractorAgreement,
        meta: {
            requiresAuth: false, // Add meta field to indicate protected route
            layout: 'default'
            // layout: 'default'
        },
    },
    {
        path: "/contact-us",
        name: "contactus",
        component: contactus,
        meta: {
            requiresAuth: true, // Add meta field to indicate protected route
            layout: 'main'
            // layout: 'default'
        },
    },
    // ------------------------
    
    {
        path: "/protection-plan/commission-rules",
        name: "commissionRules",
        component: commisionRules,
        meta: {
            requiresAuth: true, // Add meta field to indicate protected route
            layout: 'main'
            // layout: 'default'
        },
    },
    {
        path: "/learning-hub",
        name: "learningHub",
        component: gallery,
        meta: {
            requiresAuth: true, // Add meta field to indicate protected route
            layout: 'main'
        },
    },
    {
        path: "/sso",
        name: "ssoLogin",
        component: ssoLogin,
        meta: {
            requiresAuth: false, // Add meta field to indicate protected route
            layout: 'auth'
        },
    },
    {
        path: "/network-affiliate",
        name: "networkAffiliate",
        component: networkAffiliate,
        meta: {
            requiresAuth: true, // Add meta field to indicate protected route
            layout: 'main'
        },
    },
    
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
});

router.beforeResolve((to, from, next) => {
    if (to.name) {

    }
    next();
});

router.afterEach(() => {

});




router.beforeEach((to, from, next) => {
    // Redirect root path "/" to "/login"
    if (to.path === "/") {
        return next("/login");
    }

    const backdrop = document.querySelector('.modal-backdrop');
    if (backdrop) backdrop.remove();

    document.body.classList.remove('modal-open');
    document.documentElement.style.overflow = 'auto';
    document.body.style.paddingRight = '';
    enableScroll();

    const modalEl = document.getElementById('maintenanceModal');
    if (modalEl && modalEl.classList.contains('show')) {
        modalEl.classList.remove('show');
        modalEl.style.display = '';
        modalEl.setAttribute('aria-hidden', 'true');
        modalEl.removeAttribute('aria-modal');
        modalEl.removeAttribute('role');
    }

    let tempUser = localStorage.getItem("user") ?? null;

    if ((to.path == "/login" || to.path == "/register" || to.path == "/verification") && tempUser) {
        return next({ name: "dashboard" });

    } else if (to.meta.requiresAuth) {
        if (tempUser != null) {
            return next();
        } else {
            setTimeout(() => {
                localStorage.removeItem('user')
                localStorage.removeItem('isSilentLogin')
                localStorage.removeItem('isProtectionPlans')
                localStorage.removeItem('is_from_mobile')

                return next({
                    path: '/login'
                });
            }, 300);
        }
    } else {
        return next();
    }
});

export default router;
